export const COW_STATUS_TRANSLATIONS = {
  title: "Understanding Your Cattle's Status",

  howStatusUpdatesWork: {
    title: "How Does It Work?",
    description:
      "We automatically track your cattle's status based on what you record. Each status updates whenever you log a relevant event.",
  },

  statusTypes: {
    title: "Status Types",

    healthy: {
      title: "Healthy",
      meaning: "Shows if your cattle is in good health right now.",
      becomesTrue: "When you record a positive health check",
      becomesFalse:
        "When you record a negative health check, disease treatment, injury treatment, surgery, post-operative check, or vaccination",
    },

    underTreatment: {
      title: "Under Treatment",
      meaning:
        "Shows if your cattle is currently receiving medical care or medication.",
      becomesTrue:
        "When you record any medical care such as vaccinations, disease treatments, deworming, wound treatments, surgeries, post-operative checks, or supplement administration",
      becomesFalse: "When you record a positive health check",
    },

    pregnant: {
      title: "Pregnant",
      meaning: "Shows if your cattle is expecting a calf.",
      becomesTrue: "When you record a positive pregnancy check",
      becomesFalse:
        "When you record a negative pregnancy check, abortion, birth, insemination, natural breeding, or heat detection",
    },

    inHeat: {
      title: "In Heat",
      meaning:
        "Shows if your cattle is in the reproductive cycle and ready to mate.",
      becomesTrue: "When you record heat detection",
      becomesFalse:
        "When you record a positive pregnancy check, insemination, or natural breeding",
    },

    lactating: {
      title: "Lactating",
      meaning: "Shows if your cattle is currently producing milk.",
      becomesTrue: "When you record the start of lactation",
      becomesFalse: "When you record the end of lactation or drying off",
    },
  },

  labels: {
    whatItMeans: "What does it mean?",
    whenItBecomesTrue: "When is it activated?",
    whenItBecomesFalse: "When is it deactivated?",
  },
}
